import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={28}
      height={28}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G fill="#000" fillOpacity={0.4} clipPath="url(#clip0_54_554)">
        <Path d="M14 1.64a12.363 12.363 0 014.813 23.749A12.364 12.364 0 019.188 2.61 12.277 12.277 0 0114 1.641zM14 0C6.268 0 0 6.268 0 14s6.268 14 14 14 14-6.268 14-14S21.732 0 14 0z" />
        <Path d="M18.085 21.54c-.814-.055-1.96-.335-3.079-.736-3.945-1.412-7.794-5.174-8.612-10.436-.146-.937.007-1.792.717-2.49.238-.232.45-.491.682-.73.875-.9 2.154-.923 3.06-.058.287.273.579.543.859.825a2.082 2.082 0 01.075 2.887 18.27 18.27 0 01-.68.704c-.252.251-.565.396-.901.5-.415.13-.492.305-.304.701 1.193 2.497 3.059 4.295 5.599 5.394.34.147.496.08.633-.256.3-.74.85-1.278 1.48-1.713.716-.493 1.74-.383 2.416.199.372.319.726.656 1.063 1.012a2.09 2.09 0 01-.003 2.857c-.105.115-.214.227-.315.345-.61.708-1.382 1.04-2.69.995z" />
      </G>
      <Defs>
        <ClipPath id="clip0_54_554">
          <Path fill="#fff" d="M0 0H28V28H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
